<template>
  <base-layout>
    <h1 slot="header">
      {{ `app.pages.settings.arrangement_rodo_desc`|trans }}
    </h1>
    <a slot="buttons" :href="routes.settings" class="btn btn-primary">
      <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
      {{ `app.back`|trans }}
    </a>
    <v-app id="vuetify-app">
      <v-container fluid grid-list-md v-if="existsForUser === false">
        <v-layout wrap align-start justify-left>
          <v-flex xs12>
            {{ `app.pages.rodo.description_long`|trans }}
          </v-flex>
          <v-flex xs12 pt-3>
            <a target="_blank" href="https://dietico.pl/regulamin/">
              <v-icon class="rodo_arrangement_icon" color="primary">
                description
              </v-icon>
              1. {{ `app.pages.rodo.terms_of_service`|trans }}
            </a>
          </v-flex>
          <v-flex xs12>
            <a target="_blank"
               href="https://dietico.pl/polityka-prywatnosci/">
              <v-icon class="rodo_arrangement_icon" color="primary">
                description
              </v-icon>
              2. {{ `app.pages.rodo.privacy_policy`|trans }}
            </a>
          </v-flex>
          <v-flex xs12>
            <a target="_blank"
               href="https://dietico.pl/wp-content/uploads/2022/01/Umowa-powierzenia-przetwarzania-danych-osobowych.pdf">
              <v-icon class="rodo_arrangement_icon" color="primary">
                description
              </v-icon>
              3. {{ `app.pages.rodo.attachment_1_desc`|trans }}
            </a>
          </v-flex>
        </v-layout>
        <p class="mt-4">{{ `app.pages.rodo.check_documents_info`|trans }}:</p>
        <v-form ref="form" v-model="valid">
          <v-layout row wrap align-start justify-left>
            <v-flex xs6>
              <v-select :items="companyTypesForSelect"
                        v-model="rodoData.company_type"
                        single
                        item-value="id"
                        :rules="rules.companyType"
                        item-text="label"
                        :label="trans(`app.pages.rodo.company_type`)"
                        placeholder="Wybierz..."
              ></v-select>
            </v-flex>
          </v-layout>

          <v-layout wrap align-start justify-left v-if="rodoData.company_type">
            <v-flex xs6 v-if="rodoData.company_type !== 2">
              <v-text-field
                  v-model="rodoData.full_name"
                  :rules="rules.fullName"
                  :label="[rodoData.company_type === 4 ? trans('app.pages.rodo.representative_full_name') : trans('app.pages.rodo.full_name') ]"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-if="rodoData.company_type !== 1">
              <v-text-field
                  v-model="rodoData.company_name"
                  :rules="rules.companyName"
                  :label="trans('app.pages.rodo.company_name')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                  v-model="rodoData.postal_code"
                  :rules="rules.postalCode"
                  :label="trans('app.pages.rodo.postal_code')"
              ></v-text-field>
            </v-flex>

            <v-flex xs6>
              <v-text-field
                  v-model="rodoData.city"
                  :rules="rules.city"
                  :label="trans('app.pages.rodo.city')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                  v-model="rodoData.address"
                  :rules="rules.address"
                  :label="trans('app.pages.rodo.address_input_label')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-if="rodoData.company_type === 4">
              <v-text-field
                  v-model="rodoData.nip_tin_vat"
                  :rules="rules.nipTinVat"
                  :label="trans('app.pages.rodo.nip_tin_vat')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-if="rodoData.company_type === 4">
              <v-text-field
                  v-model="rodoData.country"
                  :rules="rules.country"
                  :label="trans('app.pages.rodo.country')"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-if="rodoData.company_type === 3">
              <v-text-field
                  v-model="rodoData.enterpreneur_register_company"
                  :rules="rules.enterpreneurRegisterCompany"
                  :label="trans('app.pages.rodo.enterpreneur_register_company')"
                  :hint="trans('app.pages.rodo.enterpreneur_register_company_input_hint')"
                  persistent-hint
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-if="rodoData.company_type === 3">
              <v-text-field
                  v-model="rodoData.krs_number"
                  :rules="rules.krsNumber"
                  :label="trans('app.pages.rodo.krs_number')"
                  type="number"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-if="rodoData.company_type === 3">
              <v-text-field
                  v-model="rodoData.regon"
                  :rules="rules.regon"
                  :label="trans('app.pages.rodo.regon')"
                  type="number"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-if="rodoData.company_type === 2 || rodoData.company_type === 3">
              <v-text-field
                  v-model="rodoData.nip"
                  :rules="rules.nip"
                  :label="trans('app.pages.rodo.nip')"
                  type="number"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 v-if="rodoData.company_type === 3">
              <v-text-field
                  v-model="rodoData.share_capital"
                  :rules="rules.shareCapital"
                  :label="trans('app.pages.rodo.share_capital')"
                  suffix="zł"
                  type="number"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 class="confirm-checkbox">
              <v-checkbox
                  :rules="rules.confirmCheckbox1"
                  :label="trans('app.pages.rodo.confirm_checkbox_description_1')"
                  :color="`success`"
              ></v-checkbox>
              <v-checkbox
                  :rules="rules.confirmCheckbox2"
                  :label="trans('app.pages.rodo.confirm_checkbox_description_2')"
                  :color="`success`"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 text-center>
              <v-btn v-if="rodoData.company_type" :loading="loading" :disabled="!valid || loading" color="primary" @click="signRodo()">
                {{ 'app.pages.rodo.sign_document' | trans }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
      <v-container fluid grid-list-md v-if="existsForUser !== false">
        <v-layout row wrap align-center justify-center>
          <v-flex xs12>
            {{ `app.pages.rodo.description_long`|trans }}
          </v-flex>
          <v-flex xs12 pt-3>
            <a target="_blank" href="https://dietico.pl/regulamin/">
              <v-icon class="rodo_arrangement_icon" color="primary">
                description
              </v-icon>
              1. {{ `app.pages.rodo.terms_of_service`|trans }}
            </a>
          </v-flex>
          <v-flex xs12>
            <a target="_blank"
               href="https://dietico.pl/polityka-prywatnosci/">
              <v-icon class="rodo_arrangement_icon" color="primary">
                description
              </v-icon>
              2. {{ `app.pages.rodo.privacy_policy`|trans }}
            </a>
          </v-flex>
          <v-flex xs12>
            <a target="_blank"
               href="https://dietico.pl/wp-content/uploads/2022/01/Umowa-powierzenia-przetwarzania-danych-osobowych.pdf">
              <v-icon class="rodo_arrangement_icon" color="primary">
                description
              </v-icon>
              3. {{ `app.pages.rodo.attachment_1_desc`|trans }}
            </a>
          </v-flex>
          <v-flex xs12 text-center>
            {{ trans(`app.pages.rodo.signed`) }}: {{ signedDate | format_date() }}
          </v-flex>
          <v-flex xs12 text-center>
            <v-btn color="primary" :loading="loading" :disabled="loading" @click="downloadRodo()">
              {{ `app.download`|trans }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-app>
  </base-layout>
</template>

<script>
import {mapGetters} from 'vuex';
import {trans} from "../../app";
import RulesBuilder from "../../utils/rulesBuilder";

export default {
  props: {
    'routes': Object,
    'exists_for_user': Boolean,
    'signed_date': String
  },
  data: () => ({
    companyTypesForSelect: [
      {label: trans('app.pages.rodo.company_type_individual'), id: 1},
      {label: trans('app.pages.rodo.company_type_company_pl'), id: 2},
      {label: trans('app.pages.rodo.company_type_partnership_pl'), id: 3},
      {label: trans('app.pages.rodo.company_type_company_abroad'), id: 4},
    ],
    rodoData: {},
    valid: false,
    rulesBuilder: new RulesBuilder(),
    loading: false,
    existsForUser: false,
    signedDate: null,
  }),
  watch: {
    company_type: function () {
      this.$refs.form.resetValidation();
    }
  },
  created() {
    setTimeout(() => {
      window.Echo.private('rodo-pdf-created-' + window.user.id)
          .listen('RodoPdfCreatedEvent', (e) => {
            axios.get(e.url, {
              responseType: 'arraybuffer',
            }).then(({data}) => {
              const downloadUrl = window.URL.createObjectURL(new Blob([data]));
              const link = document.createElement('a');
              link.href = downloadUrl;
              link.setAttribute('download', e.fileName);
              document.body.appendChild(link);
              link.click();
              link.remove();
              this.loading = false;
            }).catch((error) => {
              this.loading = false;
              this.sentryCaptureException(error);
            });
          });

    }, 1000);
    this.existsForUser = this.exists_for_user;
    this.signedDate = this.signed_date;
  },
  mounted() {
    this.$root.$on('stored', this.reload);
  },
  computed: {
    ...mapGetters(['hasPermission']),
    company_type() {
      return this.rodoData.company_type;
    },
    rules: function () {
      return {
        companyType: [
          ...this.rulesBuilder
              .addRequiredRule(trans('app.pages.rodo.company_type'))
              .getRules()
        ],
        fullName: [
          ...this.rulesBuilder
              .addRequiredRule(trans('app.pages.rodo.full_name'))
              .addMaxLengthRule(trans('app.pages.rodo.full_name'), 255)
              .getRules()
        ],
        postalCode: [
          ...this.rulesBuilder
              .addRequiredRule(trans('app.pages.rodo.postal_code'))
              .addMaxLengthRule(trans('app.pages.rodo.postal_code'), 30)
              .getRules()
        ],
        city: [
          ...this.rulesBuilder
              .addRequiredRule(trans('app.pages.rodo.city'))
              .addMaxLengthRule(trans('app.pages.rodo.city'), 255)
              .getRules()
        ],
        address: [
          ...this.rulesBuilder
              .addRequiredRule(trans('app.pages.rodo.address'))
              .addMaxLengthRule(trans('app.pages.rodo.address'), 255)
              .getRules()
        ],
        companyName: [
          ...this.rulesBuilder
              .addRequiredRule(trans('app.pages.rodo.company_name'))
              .addMaxLengthRule(trans('app.pages.rodo.company_name'), 255)
              .getRules()
        ],
        nip: [
          ...this.rulesBuilder
              .addRequiredRule(trans('app.pages.rodo.nip'))
              .addMaxLengthRule(trans('app.pages.rodo.nip'), 30)
              .getRules()
        ],
        enterpreneurRegisterCompany: [
          ...this.rulesBuilder
              .addRequiredRule(trans('app.pages.rodo.enterpreneur_register_company'))
              .addMaxLengthRule(trans('app.pages.rodo.enterpreneur_register_company'), 255)
              .getRules()
        ],
        krsNumber: [
          ...this.rulesBuilder
              .addRequiredRule(trans('app.pages.rodo.krs_number'))
              .addMaxLengthRule(trans('app.pages.rodo.krs_number'), 30)
              .getRules()
        ],
        regon: [
          ...this.rulesBuilder
              .addRequiredRule(trans('app.pages.rodo.regon'))
              .addMaxLengthRule(trans('app.pages.rodo.regon'), 30)
              .getRules()
        ],
        shareCapital: [
          ...this.rulesBuilder
              .addRequiredRule(trans('app.pages.rodo.share_capital'))
              .addMaxLengthRule(trans('app.pages.rodo.share_capital'), 30)
              .getRules()
        ],
        nipTinVat: [
          ...this.rulesBuilder
              .addRequiredRule(trans('app.pages.rodo.nip_tin_vat'))
              .addMaxLengthRule(trans('app.pages.rodo.nip_tin_vat'), 30)
              .getRules()
        ],
        country: [
          ...this.rulesBuilder
              .addRequiredRule(trans('app.pages.rodo.country'))
              .addMaxLengthRule(trans('app.pages.rodo.country'), 30)
              .getRules()
        ],
        confirmCheckbox1: [
          ...this.rulesBuilder
              .addConfirmCheckboxRule(trans('app.pages.rodo.confirm_checkbox_description_1',))
              .getRules()
        ],
        confirmCheckbox2: [
          ...this.rulesBuilder
              .addConfirmCheckboxRule(trans('app.pages.rodo.confirm_checkbox_description_2',))
              .getRules()
        ]
      }
    },
  },
  methods: {
    signRodo() {
      if (this.$refs.form.validate() === false) {
        return;
      }
      axios.post(this.routes.rodo_sign, this.rodoData)
          .then((response) => {
            this.loading = true
            this.signedDate = response.data.signedDate;
            this.existsForUser = true;
          }).catch(error => {
        this.loading = false;
        this.sentryCaptureException(error);
      })
    },
    downloadRodo() {
      axios.post(this.routes.rodo_create_pdf)
          .then(() => {
            this.loading = true;
          })
          .catch(error => {
            this.loading = false;
            this.sentryCaptureException(error);
          })
    },
  },
};
</script>
<style scoped>
.confirm-checkbox .v-input--checkbox {
  margin-top: 0;
}
</style>
